import * as React from 'react';
import { Badge } from "antd";

type UnreadBadgeProps = {
    count: number,
    style?: object,
    size?: "small" | "default",
    offset?: [number, number],
    overflow?: number,
    children?: React.ReactNode
}

export const UnreadBadge = ({count, style, size, offset, overflow, children}: UnreadBadgeProps) => {
    return (
        <Badge 
            overflowCount={overflow}
            count={count} 
            style={{
                backgroundColor: "rgb(243, 73, 33)", 
                boxShadow: "none", 
                ...style
            }}
            size={size}
            offset={offset}
        >
            {children}
        </Badge>
    )
};